// {
// "name": "iconic-timeline-second.js",
// "author": "Arham Web Works"
// "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get("iconic-timeline-second")) return;

  class IconicTimelineSecond extends HTMLElement {
    connectedCallback() {
      this.initSwiperUtils();
      document.addEventListener("shopify:section:load", (e) => {
        if (e.target.contains(this)) this.initSwiperUtils();
      });
    }
    initSwiperUtils() {
      const swiperEl = this.querySelector(".swiper-container");
      if (!swiperEl) return;

      const tryInitialize = () => {
        const swiper = swiperEl.swiper;
        const currentEl = this.querySelector(".iconic-current-slide");
        const totalEl = this.querySelector(".iconic-total-slides");
        const circleEl = this.querySelector(".circle-progress");
        if (!swiper) {
          setTimeout(tryInitialize, 100);
          return;
        }
        const update = () => {
          const current = swiper.realIndex + 1;
          const total = swiper.slides.length;
          const percent = (current / total) * 100;
          if (currentEl) currentEl.textContent = current;
          if (totalEl) totalEl.textContent = total;
          if (circleEl) {
            const radius = parseFloat(circleEl.getAttribute("r")) || 0;
            const circleLen = 2 * Math.PI * radius;
            const offset = circleLen - (percent / 100) * circleLen;
            const speed = parseFloat(swiperEl.getAttribute("data-speed")) || 4.3;

            circleEl.style.transition = `stroke-dashoffset ${speed}s linear`;
            circleEl.style.strokeDasharray = circleLen;
            circleEl.style.strokeDashoffset = offset;
          }
        };
        const equalizeHeights = () => {
          const slides = swiperEl.querySelectorAll(".swiper-slide");
          if (!slides.length) return;
          slides.forEach(slide => {
            slide.style.height = "auto";
          });
          requestAnimationFrame(() => {
            let maxHeight = 0;

            slides.forEach(slide => {
              const height = slide.offsetHeight;
              if (height > maxHeight) maxHeight = height;
            });

            slides.forEach(slide => {
              slide.style.height = `${maxHeight}px`;
            });
          });
        };
        swiper.on("slideChange", update);
        swiper.on("autoplayStart", update);
        update();
        setTimeout(equalizeHeights, 100);
        window.addEventListener("resize", equalizeHeights);
      };
      tryInitialize();
    }
  }
  customElements.define("iconic-timeline-second", IconicTimelineSecond);
})();
